import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Card } from '@comparethemarketau/manor-card';

// component
import { CompareCheckbox } from '../common/compare_checkbox';
import { GetInTouch } from '../common/get_in_touch';
import { ProceedWithProvider } from '../common/proceed_with_provider';
import { ViewProductDetails } from '../common/view_product_details';
import { Separator } from '../common/separator';

// widget
import { ProductSummary } from '../widget/product_summary';
import { ProductAdditional } from '../widget/product_additional';
import { ProductPriceCard } from '../widget/product_price_card';
import { ProductIncluded } from '../widget/product_included';
import { ProceedHelpText } from '../common/proceed_help_text';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        minHeight: '35.2rem',
        border: 'unset'
    },
    leftContainer: {
        display: 'flex'
    },
    centralContainer: {
        flexGrow: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: {
            top: theme.spacing[12],
            right: theme.spacing[8],
            left: theme.spacing[24]
        }
    },
    rightConainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: '38.2rem',
        maxWidth: '38.2rem',
        padding: {
            top: '2rem',
            right: '2rem',
            bottom: '0.8rem',
            left: '2rem'
        }
    },
    viewProductDetails: {
        paddingTop: theme.spacing[12],
        paddingBottom: theme.spacing[12]
    }
}));

const ProductCardLg = ({ quote, index }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const productId = quote.get('productMeta').get('id');

    return (
        <Card
            key={`product-card-${productId}`}
            className={classNames('test-policyProductCard-md', classes.container)}
            margin={['0', '0', '32', '0']}
            padding={['0']}
            boxShadow={false}
        >
            <div className={classNames('test-policyProductCard-left', classes.leftContainer)}>
                <CompareCheckbox quote={quote} />
            </div>
            <Separator type="vertical" insideFlexbox />
            <div className={classNames('test-policyProductCard-central', classes.centralContainer)}>
                <ProductSummary quote={quote} />
                <ProductAdditional quote={quote} />
                <ProductIncluded quote={quote} />
                <Separator type="horizontal" insideFlexbox />
                <ViewProductDetails quote={quote} className={classes.viewProductDetails} />
            </div>
            <div className={classNames('test-policyProductCard-right', classes.rightConainer)}>
                <ProductPriceCard quote={quote} />
                <GetInTouch quote={quote} />
                <ProceedWithProvider quote={quote} currentIndex={index} />
                <ProceedHelpText />
            </div>
        </Card>
    );
};

ProductCardLg.propTypes = {
    quote: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired
};

export { ProductCardLg };
